const legacyVariant = new URL(window.location.href).searchParams.get('variant');
if (legacyVariant) {
  for (const data of document.querySelectorAll('[data-wallet-legacy-links]')) {
    try {
      const links = JSON.parse(data.textContent);
      if (!links?.[legacyVariant]) continue;
      const target = new URL(links[legacyVariant], window.location.origin);
      if (target.origin !== window.location.origin || target.pathname === window.location.pathname) continue;
      const original = new URL(window.location.href);
      for (const [key, value] of original.searchParams) if (key !== 'variant') target.searchParams.append(key, value);
      target.hash = original.hash;
      window.location.replace(target.href);
      break;
    } catch {
      continue;
    }
  }
}
